import { AnalyticsBrowser } from '@segment/analytics-next';

// Segment never resolves user() when its CDN is blocked; don't hold Amplitude back for it.
export const SEGMENT_USER_TIMEOUT_MS = 3000;

export const getSegmentAnonymousId = async (
  analyticsBrowser: AnalyticsBrowser | null,
): Promise<string | undefined> => {
  if (!analyticsBrowser) return undefined;

  const timeout = new Promise<undefined>(resolve =>
    setTimeout(() => resolve(undefined), SEGMENT_USER_TIMEOUT_MS),
  );

  try {
    const user = await Promise.race([analyticsBrowser.user(), timeout]);
    return user?.anonymousId() ?? undefined;
  } catch {
    return undefined;
  }
};
